import { RequestHistoryType } from 'data/Form/RequestHistory/types'
import { OrderType } from 'data/Order/types'
import fetchApi from 'utils/fetchApi'
import { getApiUrl } from 'utils/urlBuilder'

const SECONDS_IN_DAY = 24 * 60 * 60

export const historical = (before: number = Date.now(), days = 90, limit = 50) => {
  const after = before - SECONDS_IN_DAY * days * 1000
  return fetchApi<Array<OrderType>>({
    auth: true,
    body: {
      after,
      before: before - 1,
      limit
    },
    method: 'POST',
    url: getApiUrl('nabu-gateway/orders/history')
  })
}

export const requestHistory = (date: RequestHistoryType) =>
  fetchApi({
    auth: true,
    method: 'GET',
    url: getApiUrl(`nabu-gateway/orders/trade-history-csv?year=${date.year}`)
  })
